import { useExportReportQuery } from '@/state/slices/studies';

/**
 * Fetches the PDF blob for the preview pane.
 *
 * The blob is cached and invalidated by the report mutations, so this
 * deliberately does not force a refetch on mount.
 */
export function usePdfPreview(studyUuid: string | undefined) {
  const {
    data: pdfBlob,
    isLoading: pdfLoading,
    isFetching: pdfFetching,
    error: pdfError,
  } = useExportReportQuery(
    { studyUuid: studyUuid || '' },
    { skip: !studyUuid }
  );

  return {
    pdfBlob: pdfBlob ?? null,
    pdfLoading,
    pdfFetching,
    pdfError,
  };
}
